<template>
  <v-breadcrumbs
    :items="breadcrumbItems"
    class="breadcrumb-nav pa-0"
  >
    <template #item="{ item }">
      <v-breadcrumbs-item
        :to="item.to"
        :disabled="item.disabled"
        exact
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
    <template #divider>
      <PhCaretRight :size="14" />
    </template>
  </v-breadcrumbs>
</template>

<script>
import { PhCaretRight } from 'phosphor-vue';

export default {
  name: 'BreadcrumbNav',
  components: {
    PhCaretRight
  },
  data() {
    return {
      dynamicLabel: ''
    };
  },
  mounted() {
    this.$eventBus.$on('breadcrumb-dynamic-label', this.onDynamicLabel);
  },
  beforeDestroy() {
    this.$eventBus.$off('breadcrumb-dynamic-label', this.onDynamicLabel);
  },
  computed: {
    breadcrumbMap() {
      return {
        '/': this.$t('menu.breadcrumb.home'),
        '/dashboard': this.$t('menu.breadcrumb.dashboard'),
        '/customers': this.$t('menu.breadcrumb.customers'),
        '/customers/create': this.$t('menu.breadcrumb.newCustomer'),
        '/customers/update': this.$t('menu.breadcrumb.editCustomer'),
        '/customers-authorizations': this.$t('menu.breadcrumb.customerFlow'),
        '/operations': this.$t('menu.breadcrumb.operations'),
        '/reports/operations/open': this.$t('menu.breadcrumb.preSale'),
        '/reports/remittance': this.$t('menu.breadcrumb.internationalRemittances'),
        '/reports/remittance/management': this.$t('menu.breadcrumb.profitRemittances'),
        '/exchange-closing': this.$t('menu.breadcrumb.exchangeClosing'),
        '/operations/:id/detail': this.$t('menu.breadcrumb.operationDetail'),
        '/reports/exchange': this.$t('menu.breadcrumb.touristExchange'),
        '/reports/stablecoin/remittance': this.$t('menu.breadcrumb.stablecoinRemittances'),
        '/reports/stablecoin/management': this.$t('menu.breadcrumb.stablecoinProfit'),
        '/reports/import-data/management': this.$t('menu.breadcrumb.duimpManagement'),
        '/correspondents': this.$t('menu.breadcrumb.corban'),
        '/operations/commissions': this.$t('menu.breadcrumb.commissions'),
        '/registrations/operation-natures': this.$t('menu.breadcrumb.operationNatures'),
        '/registrations/banks': this.$t('menu.breadcrumb.banks'),
        '/registrations/currencies': this.$t('menu.breadcrumb.spreadCurrencies'),
        '/registrations/payment-methods': this.$t('menu.breadcrumb.paymentMethods'),
        '/registrations/rate-apis': this.$t('menu.breadcrumb.quotationApis'),
        '/registrations/templates': this.$t('menu.breadcrumb.templates'),
        '/registrations/templates/select-type': this.$t('menu.breadcrumb.newTemplate'),
        '/registrations/templates/create': this.$t('menu.breadcrumb.createTemplate'),
        '/users': this.$t('menu.breadcrumb.users'),
        '/profiles': this.$t('menu.breadcrumb.profiles'),
        '/audit': this.$t('menu.breadcrumb.audit'),
        '/configuration': this.$t('menu.breadcrumb.settings'),
        '/notifications': this.$t('menu.breadcrumb.notifications'),
        '/logs/email': this.$t('menu.breadcrumb.emailsSent'),
        '/logs/whatsapp': this.$t('menu.breadcrumb.whatsappMessages'),
        '/whatsapp-inbox': this.$t('menu.breadcrumb.whatsapp'),
        '/customer-access': this.$t('menu.breadcrumb.home'),
        '/customer-access/operations': this.$t('menu.breadcrumb.newOperation'),
        '/customer-access/operation-report': this.$t('menu.breadcrumb.myOperations'),
        '/customer-access/account': this.$t('menu.breadcrumb.myAccount'),
        '/customer-access/wallets': this.$t('menu.breadcrumb.myWallets')
      };
    },

    breadcrumbItems() {
      const routeName = this.$route.name;

      const currentPath = this.$route.path;

      const items = [];

      if (routeName === 'FormEditCustomer') {
        items.push({ text: this.$t('menu.breadcrumb.customers'), to: '/customers', disabled: false });
        items.push({
          text: this.dynamicLabel || this.$t('menu.breadcrumb.editCustomer'),
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'FormCreateCustomer') {
        items.push({ text: this.$t('menu.breadcrumb.customers'), to: '/customers', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.newCustomer'), to: currentPath, disabled: true });

        return items;
      }

      if (
        routeName === 'FormEditCorrespondent' ||
        routeName === 'FormEditCorrespondentExternalAcess'
      ) {
        items.push({ text: this.$t('menu.breadcrumb.corban'), to: '/correspondents', disabled: false });
        items.push({
          text: this.dynamicLabel || this.$t('menu.breadcrumb.editCorban'),
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'FormCreateCorrespondent') {
        items.push({ text: this.$t('menu.breadcrumb.corban'), to: '/correspondents', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.newCorban'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormAuthorizationCustomer') {
        items.push({ text: this.$t('menu.breadcrumb.customerFlow'), to: '/customers-authorizations', disabled: false });
        items.push({
          text: this.dynamicLabel || this.$t('menu.breadcrumb.authorization'),
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'CustomerAccessOperationDetail') {
        items.push({ text: this.$t('menu.breadcrumb.myOperations'), to: '/customer-access/operation-report', disabled: false });
        items.push({
          text: this.dynamicLabel || this.$t('menu.breadcrumb.operationDetail'),
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'ExchangeFormEditBank') {
        items.push({ text: this.$t('menu.breadcrumb.banks'), to: '/registrations/banks', disabled: false });
        items.push({
          text: this.dynamicLabel || this.$t('menu.breadcrumb.editBank'),
          to: currentPath,
          disabled: true
        });

        return items;
      }

      if (routeName === 'ExchangeFormCreateBank') {
        items.push({ text: this.$t('menu.breadcrumb.banks'), to: '/registrations/banks', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.newBank'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormTemplate') {
        items.push({ text: this.$t('menu.breadcrumb.templates'), to: '/registrations/templates', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.newTemplate'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormEditTemplate') {
        items.push({ text: this.$t('menu.breadcrumb.templates'), to: '/registrations/templates', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.editTemplate'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'TemplateTypeSelector') {
        items.push({ text: this.$t('menu.breadcrumb.templates'), to: '/registrations/templates', disabled: false });
        items.push({ text: this.$t('menu.breadcrumb.newTemplate'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormCreateProfile') {
        items.push({ text: this.$t('menu.breadcrumb.profiles'), to: '/profiles', disabled: false });
        items.push({ text: this.$t('menu.breadcrumbNavUi.newProfile'), to: currentPath, disabled: true });

        return items;
      }

      if (routeName === 'FormEditProfile') {
        items.push({ text: this.$t('menu.breadcrumb.profiles'), to: '/profiles', disabled: false });
        items.push({ text: this.$t('menu.breadcrumbNavUi.editProfile'), to: currentPath, disabled: true });

        return items;
      }

      const matched = this.$route.matched;

      matched.forEach((record, index) => {
        if (record.path === '/' || record.path === '') return;

        const isLast = index === matched.length - 1;

        const path = record.path;
        const text = this.breadcrumbMap[path] || record.name || path;

        items.push({ text, to: path, disabled: isLast });
      });

      if (items.length === 0 && currentPath !== '/') {
        const text = this.breadcrumbMap[currentPath] || routeName || currentPath;

        items.push({ text, to: currentPath, disabled: true });
      }

      return items;
    }
  },
  methods: {
    onDynamicLabel(label) {
      this.dynamicLabel = label || '';
    }
  }
};
</script>

<style lang="scss">
/* Mesma tipografia dos títulos de tela (a fonte de display do DS): a trilha é o
   nome da página no topo, não um texto de apoio. */
.breadcrumb-nav {
  font-family: var(--tc-font-display);
  font-size: var(--tc-fs-h3);

  .v-breadcrumbs__item {
    color: var(--v-primary-base) !important;
    font-family: var(--tc-font-display);
    font-size: var(--tc-fs-h3);
    font-weight: var(--tc-fw-semibold);
    letter-spacing: var(--tc-tracking-snug);
    line-height: var(--tc-lh-tight);

    &--disabled {
      color: var(--v-primary-base) !important;
    }
  }

  .v-breadcrumbs__divider {
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    padding: 0 4px;
  }
}

/* No celular o último item é o nome do registro aberto, e nome de empresa não
   é curto. Sem limite ele quebra em três linhas e a trilha passa da altura da
   barra, empurrando o conteúdo da tela para baixo. Uma linha só, cortada no
   fim: o nome inteiro continua no cabeçalho do registro, logo abaixo. */
@media (max-width: 599px) {
  /* `.v-breadcrumbs` no seletor para empatar em especificidade com a regra do
     Vuetify que declara `flex-wrap: wrap` — sem isso a ordem dos arquivos
     decide, e a do Vuetify vem depois. */
  .v-breadcrumbs.breadcrumb-nav {
    flex-wrap: nowrap;
    /* Fica com o espaço que sobra na barra em vez de encolher junto com os
       ícones da direita: com `0 1 auto` a trilha caía para 17px e os três itens
       empilhavam, passando da altura da barra. */
    flex: 1 1 auto;
    min-width: 0;

    li {
      min-width: 0;
    }

    .v-breadcrumbs__item {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.theme--dark .breadcrumb-nav {
  .v-breadcrumbs__item {
    color: var(--v-primary-lighten2);

    &--disabled {
      color: var(--v-primary-lighten2);
    }
  }

  .v-breadcrumbs__divider {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
